export class Util {
	static getElementByIdWithQuery(p_elementId, p_basicConfiguration) {
		let l_contentEl = p_basicConfiguration.getContentElement();

		let l_result;
		if (l_contentEl) {
			if (isNaN(p_elementId)) {
				// Use rather attribute selector as we have IDs starting with number which are invalid as element ID.
				l_result = l_contentEl.querySelector(`[id='${p_elementId}']`);
			} else {
				let l_firstDig = String(p_elementId)[0];
				let l_lastDigits = p_elementId.substring(1);
				l_result = l_contentEl.querySelector(`#\\3${l_firstDig} ${l_lastDigits}`);
			}
		}
		return l_result;
	}

	static getElementsByClassNameWithQuery(p_className, p_basicConfiguration) {
		let elements = [];
		const query = "." + p_className.trim();
		let content = p_basicConfiguration.getContentElement();
		if (content) {
			elements = Array.from(content.querySelectorAll(query));
		}
		return elements;
	}

	static getElementsByTagNameWithQuery(p_tagName, p_basicConfiguration) {
		let content = p_basicConfiguration.getContentElement();
		let elements = [];

		if (content) {
			elements = Array.from(content.querySelectorAll(p_tagName));
		}
		return elements;
	}
	static displayElement(p_elementId, p_basicConfiguration) {
		return this._switchCSSClasses(
			p_elementId,
			p_basicConfiguration.css_element_visible,
			p_basicConfiguration.css_element_invisible,
			p_basicConfiguration
		);
	}

	static hideElement(p_elementId, p_basicConfiguration) {
		return this._switchCSSClasses(
			p_elementId,
			p_basicConfiguration.css_element_invisible,
			p_basicConfiguration.css_element_visible,
			p_basicConfiguration
		);
	}

	static _switchCSSClasses(p_elementId, p_classToAdd, p_classToRemove, p_basicConfiguration) {
		this._switchCSSClassesForElement(
			p_elementId,
			p_classToAdd,
			p_classToRemove,
			p_basicConfiguration
		);
	}

	static _switchCSSClassesForElement(
		p_element,
		p_classToAdd,
		p_classToRemove,
		p_basicConfiguration
	) {
		if (typeof p_element === "string" || p_element instanceof String) {
			p_element = this.getElementByIdWithQuery(p_element, p_basicConfiguration);
		}

		if (p_element) {
			let l_elementClassList = p_element.classList;
			if (p_element.classList) {
				if (p_classToAdd) {
					l_elementClassList.add(p_classToAdd);
				}
				if (l_elementClassList.contains(p_classToRemove)) {
					l_elementClassList.remove(p_classToRemove);
				}
			}
			return p_element;
		}
	}

	static _removeCSSClass(p_element, p_classToRemove) {
		if (p_element) {
			let l_elementClassList = p_element.classList;
			if (l_elementClassList.contains(p_classToRemove)) {
				l_elementClassList.remove(p_classToRemove);
			}
		}
	}

	static setModalFocus(p_basicConfiguration) {
		let l_bodyClassList = document.getElementsByTagName("body")[0];
		this._switchCSSClassesForElement(
			l_bodyClassList,
			p_basicConfiguration.css_body_modal_focus,
			p_basicConfiguration.css_body_focus,
			p_basicConfiguration
		);
	}

	static unsetModalFocus(p_basicConfiguration) {
		let l_bodyClassList = document.getElementsByTagName("body")[0];
		this._switchCSSClassesForElement(
			l_bodyClassList,
			p_basicConfiguration.css_body_focus,
			p_basicConfiguration.css_body_modal_focus,
			p_basicConfiguration
		);
	}

	static createRowCol(p_colContainingElement, p_basicConfiguration) {
		let l_row = document.createElement("DIV", p_basicConfiguration.css_row);
		let l_col = document.createElement("DIV", p_basicConfiguration.css_column);
		l_col.appendChild(p_colContainingElement);
		l_row.appendChild(l_col);
		return l_row;
	}

	static getParamsEncodedInURL(p_guid, p_mandator, p_language) {
		let l_b64EncodedParams = btoa(
			"guid=" + p_guid + "&mandator=" + p_mandator + "&lang=" + p_language
		);
		let l_search = window.location.search;

		//check if already doc param is set in url, if yes, replace
		if (l_search != null && l_search.length > 0 && l_search.indexOf("doc=") > 0) {
			if (l_search.indexOf("?") == 0) {
				l_search = l_search.substring(1);
			}
			let params = this.splitParameterValuesInUrl(l_search);
			params["doc"] = l_b64EncodedParams;
			let l_resultURL = this.getAbsolutePath() + "?";
			for (var key in params) {
				l_resultURL += key + "=" + params[key] + "&";
			}
			return l_resultURL.substring(0, l_resultURL.length - 1);
		}
		// if doc is not set as param in url, check whether it is the first param or an additional one
		else {
			let l_prefix = "?doc=";
			if (window.location.search.length > 0) {
				l_prefix = "&doc=";
			}
			return window.location.href + l_prefix + l_b64EncodedParams;
		}
	}

	static storeConfigInBrowserCache(p_config) {
		sessionStorage.setItem("config", JSON.stringify(p_config));
	}

	static loadConfigFromBrowserCache() {
		if (sessionStorage.getItem("config")) {
			let parsed = JSON.parse(sessionStorage.getItem("config"));
			parsed.__proto__ = new BasicConfiguration();
			return parsed;
		}
	}

	static decodeParams() {
		let l_url = window.location.search;
		if (l_url && l_url.length > 0 && l_url.indexOf("?") == 0) {
			try {
				let query = l_url.substring(1);
				// get doc url param
				query = this.splitParameterValuesInUrl(query)["doc"];
				if (query != undefined) {
					// parse base64 encoded values
					query = atob(query);
					return this.splitParameterValuesInUrl(query);
				}
			} catch (error) {
				console.log("Error resolving encoded parameter from url %s", error);
			}
		}
		return {};
	}

	static getAbsolutePath() {
		return window.location.origin + window.location.pathname;
	}

	static splitParameterValuesInUrl(p_url) {
		let parameters = {};
		let keyValues = p_url.split(/&/);
		for (let keyValue of keyValues) {
			let keyValuePairs = keyValue.split(/=/);
			let key = keyValuePairs[0];
			let value = keyValuePairs[1];
			parameters[key] = value;
		}
		return parameters;
	}

	static dataURItoBlob(dataURI) {
		var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
		var binary = atob(dataURI.split(",")[1]);
		var array = [];
		for (var i = 0; i < binary.length; i++) {
			array.push(binary.charCodeAt(i));
		}
		return new Blob([new Uint8Array(array)], { type: mime });
	}

	static immageObjects = {
		// ObjectURL with 1x1 px transparent image
		dummy: URL.createObjectURL(
			Util.dataURItoBlob(
				"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACklEQVR42mMAAQAABQABoIJXOQAAAABJRU5ErkJggg=="
			)
		),

		"new.gif": URL.createObjectURL(
			Util.dataURItoBlob(
				"data:image/gif;base64,R0lGODlhGQAOAPcAAAAAAIAAAACAAICAAAAAgIAAgACAgMDAwMDcwKbK8EAgAGAgAIAgAKAgAMAgAOAgAABAACBAAEBAAGBAAIBAAKBAAMBAAOBAAABgACBgAEBgAGBgAIBgAKBgAMBgAOBgAACAACCAAECAAGCAAICAAKCAAMCAAOCAAACgACCgAECgAGCgAICgAKCgAMCgAOCgAADAACDAAEDAAGDAAIDAAKDAAMDAAODAAADgACDgAEDgAGDgAIDgAKDgAMDgAODgAAAAQCAAQEAAQGAAQIAAQKAAQMAAQOAAQAAgQCAgQEAgQGAgQIAgQKAgQMAgQOAgQABAQCBAQEBAQGBAQIBAQKBAQMBAQOBAQABgQCBgQEBgQGBgQIBgQKBgQMBgQOBgQACAQCCAQECAQGCAQICAQKCAQMCAQOCAQACgQCCgQECgQGCgQICgQKCgQMCgQOCgQADAQCDAQEDAQGDAQIDAQKDAQMDAQODAQADgQCDgQEDgQGDgQIDgQKDgQMDgQODgQAAAgCAAgEAAgGAAgIAAgKAAgMAAgOAAgAAggCAggEAggGAggIAggKAggMAggOAggABAgCBAgEBAgGBAgIBAgKBAgMBAgOBAgABggCBggEBggGBggIBggKBggMBggOBggACAgCCAgECAgGCAgICAgKCAgMCAgOCAgACggCCggECggGCggICggKCggMCggOCggADAgCDAgEDAgGDAgIDAgKDAgMDAgODAgADggCDggEDggGDggIDggKDggMDggODggAAAwCAAwEAAwGAAwIAAwKAAwMAAwOAAwAAgwCAgwEAgwGAgwIAgwKAgwMAgwOAgwABAwCBAwEBAwGBAwIBAwKBAwMBAwOBAwABgwCBgwEBgwGBgwIBgwKBgwMBgwOBgwACAwCCAwECAwGCAwICAwKCAwMCAwOCAwACgwCCgwECgwGCgwICgwKCgwMCgwOCgwADAwCDAwEDAwGDAwIDAwKDAwP/78KCgpICAgP8AAAD/AP//AAAA//8A/wD//////yH5BAEAAE8ALAAAAAAZAA4ABwhpAJ8IHEiwoMGDAvcRVFhwH0OEDh0+iciQosSJCS1q3EhxoEMAEUECGCmSIsiLCUd+3HdyZUiUKVnKJLlS5cmFMlmWDElSZcOcMy2ebOnR5UyaOVtW5MjUYsKMEYtK7Ihw4sOnOKtq1RoQADs="
			)
		),

		"global_doc.gif": URL.createObjectURL(
			Util.dataURItoBlob(
				"data:image/gif;base64,R0lGODlhEQATAPcAAAAAAIAAAACAAICAAAAAgIAAgACAgMDAwMDcwKbK8DRLY5Gjuaezxr/I19Ha7OPs+/Dw7vv8/QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/78KCgpICAgP8AAAD/AP//AAAA//8A/wD//////yH5BAEAAPkALAAAAAARABMABwhsAPMJHEiwoMGDCBMmbMCQIYOHDRA2iECxIgMFEQ0yqFhxQQOMGjlSXKCgZEiRERaQPIlyZcGNKB+4JAiT4wOZCgwuiOlg5sCdNh/0zFkQaEWhDXwKNBpBqIOkRAnuVEmVatSfJbNqvaqwq9eAADs="
			)
		),
	};

	static getImmageObjectUrl(name) {
		return Util.immageObjects[name];
	}

	// Format custom field value according to custom field spec. from document type
	static formatCF(config, cfSpec, language, value) {
		let lang = language || "en";
		let format = cfSpec.format;
		let formattedValue = value;
		if (format == "B") {
			formattedValue = config.getTranslatedLabel(
				lang,
				value ? "common.true" : "common.false"
			);
		}
		return formattedValue;
	}
}
